import { EnterpriseFilterOptions_EntityType, EnterpriseFilterOptions_FilterType } from '__generated__/graphql-types';
import type { EnterpriseFilterOptions_EnterpriseUserFilterLabel } from '__generated__/graphql-types-do-not-use';

import { FilterOptionType } from 'bundles/enterprise-admin-messages/types';

export const toEnterpriseFilterOptionsFilterType = (filterType: string): EnterpriseFilterOptions_FilterType => {
  switch (filterType) {
    case 'PROGRAMS':
      return EnterpriseFilterOptions_FilterType.EnterpriseFilterOptionTypeProgram;
    case 'CONTRACTS':
      return EnterpriseFilterOptions_FilterType.EnterpriseFilterOptionTypeContract;
    case 'ENROLLMENTS':
      return EnterpriseFilterOptions_FilterType.EnterpriseFilterOptionTypeContent;
    default:
      return EnterpriseFilterOptions_FilterType.EnterpriseFilterOptionTypeInvalid;
  }
};

export const toLegacyFilterOptionType = (element: EnterpriseFilterOptions_EnterpriseUserFilterLabel): string => {
  switch (element.entityType) {
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeContract:
      return FilterOptionType.CONTRACT;
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeCourse:
      return FilterOptionType.COURSE;
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeSpecialization:
      return FilterOptionType.SPECIALIZATION;
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeProgram:
      return FilterOptionType.PROGRAM;
    default:
      throw new Error(`Cannot handle unknown entityType: ${element.entityType}.`);
  }
};

export const toLegacyFilterOptionId = (element: EnterpriseFilterOptions_EnterpriseUserFilterLabel): string => {
  switch (element.entityType) {
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeContract:
      return `contract~${element.id}`;
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeCourse:
      return `product~VerifiedCertificate!~${element.id}`;
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeSpecialization:
      return `product~Specialization!~${element.id}`;
    case EnterpriseFilterOptions_EntityType.FilterOptionEntityTypeProgram:
      return `program~${element.id}`;
    default:
      throw new Error(`Cannot handle unknown entityType: ${element.entityType}.`);
  }
};
